import { Platform, PLATFORM_TO_HUMAN_READABLE } from "interfaces/db";
import { useAutodialerSettings } from "../hooks/useAutodialerSettings";

// Platform logo mapping (only for platforms that have assets available)
export const PLATFORM_TO_LOGO: Partial<Record<Platform, string>> = {
    [Platform.HUBSPOT]: "/assets/hubspot-logo.svg",
    [Platform.SALESLOFT]: "/assets/salesloft-logo.png",
    [Platform.OUTREACH]: "/assets/outreach-logo.svg",
    [Platform.OPENPHONE]: "/assets/openphone.png",
    [Platform.APOLLO]: "/assets/apollo.jpeg",
    [Platform.GONG_ENGAGE]: "/assets/gong.png",
    [Platform.AMPLEMARKET]: "/assets/amplemarket.svg",
    [Platform.FIVENINE]: "/assets/five9.png",
    [Platform.SALESFORCE]: "/assets/salesforce.svg",
    [Platform.ZOHO]: "/assets/zoho.svg",
    [Platform.CLAY]: "/assets/clay.png",
    [Platform.GOOGLE_SHEETS]: "/assets/sheets.png",
    [Platform.VANILLASOFT]: "/assets/vanillasoft.png",
    [Platform.UNIFY]: "/assets/unify.png",
    [Platform.LEMLIST]: "/assets/lemlist.png",
    [Platform.GOHIGHLEVEL]: "/assets/gohighlevel.svg",
    [Platform.AGENTLOCATOR]: "/assets/agentlocator.png",
    [Platform.CLOSE]: "/assets/close.svg",
}

export const ELIGIBLE_DIALER_PLATFORMS = [
    Platform.HUBSPOT,
    Platform.SALESLOFT,
    Platform.OUTREACH,
    Platform.OPENPHONE,
    Platform.APOLLO,
    Platform.GONG_ENGAGE,
    Platform.CLAY,
    Platform.GOOGLE_SHEETS,
    Platform.VANILLASOFT,
    Platform.SALESFORCE,
    Platform.AMPLEMARKET,
    Platform.ZOHO,
    Platform.UNIFY,
    Platform.LEMLIST,
    Platform.GOHIGHLEVEL,
    Platform.AGENTLOCATOR,
    Platform.CLOSE
]

// Only show platforms that have logos
const PLATFORMS_WITH_LOGOS = ELIGIBLE_DIALER_PLATFORMS.filter(platform => PLATFORM_TO_LOGO[platform]);

export function PlatformSelector() {
    const { updateSelectedPlatform } = useAutodialerSettings();
    const renderPlatform = (platform: Platform) => {
        const logo = PLATFORM_TO_LOGO[platform];
        return (
            <div 
                onClick={() => updateSelectedPlatform(platform)} 
                key={platform} 
                className={`
                    group relative h-28 p-4 rounded-xl cursor-pointer 
                    transition-all duration-300 ease-in-out
                    bg-white hover:bg-gray-50 border border-gray-200 hover:border-gray-300 hover:shadow-md
                    flex flex-col items-center justify-center gap-3
                `}
            >
                <div className={`
                    w-10 h-10 rounded-lg flex items-center justify-center
                    bg-gray-50 group-hover:bg-gray-100
                    transition-colors duration-200
                `}>
                    <img
                        src={logo}
                        alt={`${PLATFORM_TO_HUMAN_READABLE[platform]} logo`}
                        className="w-7 h-7 object-contain"
                    />
                </div>
                <span className={`
                    text-sm font-semibold text-center leading-tight
                    text-gray-800
                `}>
                    {PLATFORM_TO_HUMAN_READABLE[platform]}
                </span>
            </div>
        )
    }

    return (
        <div className="p-4 grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-4 w-full">
            {PLATFORMS_WITH_LOGOS.map(renderPlatform)}
        </div>
    );
}